import React, {useEffect} from 'react';
import {Avatar, Button, Card, Col, Dropdown, Flex, Layout, Menu, MenuProps, Row, Spin, Tag, theme} from 'antd';
import './../App.css';
import {Link, useNavigate} from "react-router-dom";
import {useAppSelector, useAppDispatch} from '../feature/tools'
import {fetchProjects, resetProject} from "../feature/project/projectsSlice";
import {Project} from "../feature/project/project";
import {Content, Header} from "antd/es/layout/layout";
import Meta from "antd/es/card/Meta";
import {Status} from "../feature/project/status";
import {AppProjectModal} from "./project/AddProjectModal";
import {UserMenu} from "../components/UserMenu";
import {fetchUser} from "../feature/project/userSlice";
import {useCookies} from "react-cookie";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBolt, faCrown, faSpinner, faUsers} from "@fortawesome/free-solid-svg-icons";

const Main = () => {
    const dispatch = useAppDispatch()
    const projects = useAppSelector(state => state.projects.projects)
    const [newProject, setNewProject] = React.useState<Project | undefined>(undefined)
    const {
        token: {
            colorBgContainer
        },
    } = theme.useToken();

    const [cookies] = useCookies(['token'])
    const [loading, setLoading] = React.useState(false)
    const user = useAppSelector(state => state.users.currentUser)
    const navigate = useNavigate()

    useEffect(() => {
        if (!user && !cookies.token) {
            navigate('/sign-in')
        }
    }, [user, cookies]);


    const items: MenuProps['items'] = [
        {
            label: <span style={{fontWeight: 700}}>Projects</span>,
            key: 'SubMenu',
            children: projects.map((project: Project) => ({
                label: <Link to={`/projects/${project.id}`}>{project.title}</Link>,
                key: project.id
            }))
        },
    ];

    useEffect(() => {
        dispatch(fetchProjects())
    }, [user])

    useEffect(() => {
        dispatch(resetProject())
        setLoading(true)
        dispatch(fetchUser())
            .finally(() => setLoading(false))
    }, []);

    return (
        <>
            {user && !loading ?
                <Layout style={{
                    height: "100%"
                }}>
                    <Header style={{padding: '0 20px 0 20px', background: colorBgContainer}}>
                        <Flex justify={'space-between'} align={'center'}>
                            <Flex align={'center'} gap={56}>
                                <div style={{padding: '16px', fontSize: '24px'}}>
                                    <Link to={'/'} style={{color: '#000000'}}>
                                        <Flex align={'center'} gap={'small'} style={{lineHeight: '24px'}}>
                                            <img alt={'logo'} src={'/logo.svg'} style={{width: 24}}/>
                                            narrator
                                        </Flex>
                                    </Link>
                                </div>
                                <Flex align={'center'} gap={24}>
                                    <Menu disabledOverflow mode="horizontal" items={items}/>
                                    <Button type={'primary'} onClick={() => setNewProject(new Project())}>Create
                                        Project</Button>
                                </Flex>
                            </Flex>
                            <Flex align={'center'} gap={16}>
                                <UserMenu/>
                            </Flex>
                        </Flex>
                    </Header>
                    <Content style={{padding: '20px'}}>
                        <Row gutter={16}>
                            {projects.map((project: Project) => (
                                <Col span={6} key={project.id}>
                                    <Link to={`/projects/${project.id}`}>
                                        <Card
                                            className={'card-list'}
                                            cover={
                                                <>
                                                    <img
                                                        alt={project.title}
                                                        src={project?.cover ? project?.cover : '/images/placeholder.png'}
                                                        style={{aspectRatio: 1, objectFit: 'cover'}}
                                                    />
                                                    {
                                                        project.contributors?.find(c => c.userId == user.id && c.role != 'creator') ?
                                                            <Tag
                                                                style={{
                                                                    position: 'absolute',
                                                                    right: 0,
                                                                    top: 10,
                                                                    width: 'auto'
                                                                }}><FontAwesomeIcon
                                                                icon={faUsers}/></Tag>
                                                            : ''
                                                    }
                                                </>
                                            }
                                        >
                                            <Meta
                                                avatar={<Avatar src={project.icon}/>}
                                                title={project.title}
                                                description={<div style={{
                                                    whiteSpace: 'nowrap',
                                                    textOverflow: 'ellipsis',
                                                    overflow: 'hidden'
                                                }}>{project.description}</div>}
                                            />
                                        </Card>
                                    </Link>
                                </Col>
                            ))}
                        </Row>
                    </Content>
                    {newProject ?
                        <AppProjectModal
                            project={newProject}
                            visible={true}
                            onDismiss={() => setNewProject(undefined)}
                        /> : ''}
                </Layout> : <Spin size={'large'} indicator={<FontAwesomeIcon color={'#fff'} icon={faBolt} beat={true}/>}
                                  spinning={true} fullscreen={true}/>}
        </>
    );
};

export default Main;